module.exports = __webpack_public_path__ + "img/close.3d8f56ae.svg";